import * as styles from "./Sidebar.css";

import { useAtomValue } from "jotai";

import { Trans } from "@lingui/react/macro";

import { categoriesAtom } from "../../stores";
import { Panel, PanelFooter } from "../Panel";
import { NavItem } from "./NavItem";

export function Sidebar() {
  const categories = useAtomValue(categoriesAtom);

  return (
    <Panel hiddenBelow="compact">
      <div className={styles.title}>
        <span className={styles.title}>
          <Trans>Address Book</Trans>
        </span>
      </div>

      <nav className={styles.content}>
        {categories.map((category) => (
          <NavItem key={category.key} category={category} />
        ))}
      </nav>

      <PanelFooter className={styles.footer}></PanelFooter>
    </Panel>
  );
}
